import { styles } from 'assets/scss/style-templates';

const useSelectedFilesPreviewStyles = () => ({
  attachmentsPreviewContainer: {
    display: 'flex',
    gap: 1,
    height: 'auto',
    p: 1,
    backgroundColor: styles.color.baseBackground,
    border: `1px solid ${styles.color.monotoneLightDark}`,
  },
  attachmentListItemPreviewContainer: {
    display: 'flex',
    flexDirection: 'row',
    p: 0.8,
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: `1px solid ${styles.color.monotoneLightDark}`,
    borderRadius: '4px',
  },
  fileNameText: {
    fontWeight: 400,
    fontSize: '14px',
  },
  crossIcon: { color: styles.color.monotoneDarkDark },
});

export default useSelectedFilesPreviewStyles;
